import React, { FC } from 'react'
import styles from './DropDownItem.module.css'
import { useNavigate } from 'react-router-dom'
import PATH from '../../navigation/path'

type DropDownItemPropsType = {
  title: string
  id: number
  active?: boolean
  setActive: (activeOption: null | number) => void
}

const DropDownItem: FC<DropDownItemPropsType> = ({ title, id, active, setActive }) => {
  const navigate = useNavigate()

  const redirectToPage = () => {
    switch (title) {
      case 'Залы':
        navigate(PATH.siteManagementPage)
        return
      case 'Администраторы':
        navigate(PATH.administratorsManagementPage)
        return
      case 'Компании':
        navigate(PATH.companyManagementPage)
        return
      case 'Заявки':
        navigate(PATH.claimsPage)
        return
      case 'Сотрудники':
        navigate(`${PATH.companyManagementStaffPage}1`)
        return
      case 'Запросы на регистрацию':
        navigate(`${PATH.requestForRegistration}`)
        return
      case 'Профиль':
        navigate(`${PATH.profilePage}`)
        return
      case 'Главная':
        // navigate('/')
        navigate(PATH.claimManagementPage)
        return
      case 'Площадки':
        navigate(`${PATH.establishmentPage}`)
        return
      case 'Меню':
        navigate(`${PATH.menuPage}`)
        return
      case 'Отчеты':
        navigate(`${PATH.statsPage}`)
        return
      case 'Клиенты':
        navigate(`${PATH.clientControlPage}`)
        return
      case 'STR':
        navigate(`${PATH.strPage}`)
        return
    }
  }

  const onActiveItem = () => {
    setActive(id)
    redirectToPage()
  }

  return (
    <span onClick={onActiveItem} className={`${styles.dropDownItem} ${active && styles.active}`}>
      {title}
    </span>
  )
}

export default DropDownItem
